import { User } from '../../user/user.model';
import { SearchItem, SearchType } from '../core';
import { Sort, SortOrder } from '../grid';

import { ColumnId } from './model/column-id.model';

export interface SearchState {
    pending: {
        reload?: boolean;
        runSearch?: boolean;
    };

    /** as an object so that all changes are observable, even when the value is the same */
    selectedUser?: {
        value?: User;
        initialLoad?: boolean;
    };

    selectedSearchType?: {
        value?: SearchType;
        initialLoad?: boolean;
    };

    selectedDateRange?: {
        value?: {
            start?: Date;
            end?: Date;
        };
        initialLoad?: boolean;
    };

    rows?: SearchItem[];
    filteredRows?: SearchItem[];
    sortOptions?: Sort;
    filteredRowsLength?: number;
    canLoadMore?: boolean;
}

export const defaultState = (): SearchState => ({
    pending: {
        reload: true, // fake side effect for user search initial load
    },
    sortOptions: {
        columnId: ColumnId.EVENT_DATE,
        order: SortOrder.DESC,
    },
});
